<template>
  <div class="footer-class">
    <div class="footer-text-div">
      <!--        <img class="footer-image" :src="footerImagePath">-->
      <div class="footer-span" style="padding-top: 1vh">
        <span>Copyright © The Hong Kong University of Science and Technology © The Hong Kong University of Science and Technology (Guangzhou). All rights reserved.<a v-if="hostDetection()" style="color: white" href="https://beian.miit.gov.cn/#/Integrated/index"> 粤ICP备20065231号</a></span>
      </div>
      <div style="margin-top: 0.5vh">

      </div>
      <div class="footer-span">
        <span>**Special Thanks to the team from the Big Data Institute of HKUST for their contributions in developing this Recruitment System for Both Campuses.</span>
      </div>
    </div>
  </div>
</template>

<script>
import utilsMixin from "@/components/view/js/utilsMixin";
export default {
  mixins: [utilsMixin],
  name: "DesktopFooter"
}
</script>

<style scoped>

</style>
